import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorMsg, AccessionSearchResult } from '../../register-samples/register-sample-info';
import { UrlBuilder } from '../../../core';
import { EReqSmStorage } from '../ereq-sm-storage';
import { AccessionDetailsService } from '../../register-samples/service/accession-details-service';

@Component({
    selector: 'ereq-sm-landing-page',
    template: require('./ereq-sm-landing-page.component.html'),
    styles: [require('./ereq-sm-landing-page.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EreqSmLandingPage implements OnInit {

    @Input()
    public accessionDetails: any;

    public showLoading = true;

    constructor(
        private ereqSmStorage: EReqSmStorage,
        private activatedRoute: ActivatedRoute,
        private urlBuilder: UrlBuilder,
        private accessionService: AccessionDetailsService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        
    }

    public ngOnInit() {
        this.activatedRoute.params.subscribe(param => {
            if (param.accession) {
                this.ereqSmStorage.getAccessionDetails(param.accession).subscribe((result: AccessionSearchResult) => {
                    if (result.sampleRegistrationAccessionData && !result.sampleRegistrationAccessionData[0].submittedOn && result.sampleRegistrationAccessionData[0].createdOn) {
                        localStorage.setItem('resumeRegistration', result.sampleRegistrationAccessionData[0].accessionNumber);
                        this.urlBuilder.esa().sampleManagement().resumeRegistration().navigate();
                    } else if (result.errorMsg.toLowerCase() === ErrorMsg.NoPermission.toLowerCase()) {
                        this.showWarningDialog(ErrorMsg.NoPermission, ErrorMsg.AccessRequired);
                    } else if (result.errorMsg.toLowerCase() === ErrorMsg.NoAccessionFound.toLowerCase()) {
                        this.showWarningDialog();
                    } else if (result.sampleRegistrationAccessionData && result.sampleRegistrationAccessionData[0].submittedOn) {
                        localStorage.setItem('resumeRegistration', result.sampleRegistrationAccessionData[0].accessionNumber);
                        this.urlBuilder.esa().sampleManagement().resumeRegistration('view').navigate();
                    } else if (!result.isError && !result.errorMsg.length) {
                        this.autoPopulateDetails(result.sampleRegistrationAccessionData[0].accessionNumber);
                    }
                });
            }

        });
    }

    private showWarningDialog(message?: string, title?: string) {
        this.accessionService.showWarning(message, title, 'sm-confirm-dialog').subscribe((res: any) => {
            if (res && res.isCancelled === true) {
                this.urlBuilder.esa().sampleManagement().registeredSamples().navigate(); 
            }
        });
    }

    private autoPopulateDetails(accession: string) {
        this.ereqSmStorage.saveAccessionDetails(accession).subscribe((response: number) => {
            if (response === 201) {
                localStorage.setItem('resumeRegistration', accession);
                this.urlBuilder.esa().sampleManagement().resumeRegistration().navigate();
            } else {
                this.urlBuilder.esa().sampleManagement().registeredSamples().navigate();
            }
        });
    }

}
